import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const CausaleRifiutiBho: AnaColumn[] = [

    {
      itemType: "group", colCount: "2", data: [
        { type: 'campo', colVisible: false, dataField: "id", dataType: "", caption: "Codice", width: "40", hideOnEdit: true },
        { type: 'campo', dataField: "descrizione", colSpan: "2", dataType: "", caption: "Descrizione", maxSize: 255, maxLength: '255', width: 60 * aspect },
        { type: 'campo', dataField: "tipoOperazione", colSpan: "2", dataType: "", caption: "Tipo Op", maxSize: 2, maxLength: '2', width: 5 * aspect },
        { type: 'campo', dataField: "descrizioneOperazione", colSpan: "2", dataType: "", caption: "Descrizione Op", maxSize: 255, maxLength: '255', width: 60 * aspect },
        { type: 'campo', colVisible: false, dataField: "versione", hideOnEdit: true, dataType: "" },
      ]
    },
  
  ]